import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Estaba perdida, sin rumbo, sin saber por dónde empezar. El libro de la Abu me dio claridad y herramientas reales. En pocas semanas vi cambios genuinos en mi actitud y conseguí el trabajo que llevaba meses buscando. No lo puedo creer todavía.',
  author: 'Laura P.',
  location: 'Ciudad de México'
}, {
  quote: 'Era muy escéptica, pero la calidez de la Abu me convenció de darle una oportunidad. El Diario de Manifestación transformó mis mañanas por completo. Ahora empiezo cada día con propósito y claridad. Mi energía cambió de una forma que no sé cómo explicar — simplemente se siente distinto.',
  author: 'Sofía G.',
  location: 'Buenos Aires'
}, {
  quote: 'Tenía deudas y no veía ninguna salida posible. Con los Números Mágicos y el libro principal empecé a cambiar mi relación con el dinero desde adentro. Surgieron oportunidades que no estaban en mi horizonte. Mi situación financiera está mejorando mes a mes y sigo aplicando lo que aprendí.',
  author: 'Valentina R.',
  location: 'Bogotá'
}, {
  quote: 'A mis 50 años pensaba que ya era tarde para soñar. La Abu me demostró que no. El Método del Jardín Subconsciente es poderoso de verdad. Hoy estoy emprendiendo un proyecto que guardé por años y me levanto cada mañana con una ilusión que no sentía desde hace mucho.',
  author: 'Elena V.',
  location: 'Lima'
}];
export function Testimonials() {
  return <section className="py-24 px-4 bg-brand-bgAlt" data-id="element-267">
      <div className="max-w-6xl mx-auto" data-id="element-268">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-269">
          <span className="text-4xl mb-4 block" data-id="element-270">💬</span>
          <h2 className="text-3xl md:text-5xl font-bold text-brand-plum" data-id="element-271">
            Lo Que Dicen Mis Pequeños de Mi Libro "Merezco la Vida de Mis
            Sueños"
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-272">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-8 rounded-3xl shadow-sm border border-brand-gold/20 flex flex-col" data-id="element-273">
              <div className="flex gap-1 mb-6" data-id="element-274">
                {[...Array(5)].map((_, idx) => <Star key={idx} className="w-5 h-5 fill-brand-gold text-brand-gold" data-id="element-275" />)}
              </div>
              <p className="text-brand-textLight italic mb-8 flex-1 text-lg leading-relaxed" data-id="element-276">
                "{t.quote}"
              </p>
              <div className="mt-auto border-t border-brand-rose/10 pt-4" data-id="element-277">
                <p className="font-bold text-brand-plum text-lg" data-id="element-278">{t.author}</p>
                <p className="text-brand-textLight text-sm" data-id="element-279">— {t.location}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}